import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as irActions from '../../../redux/actions/irSearch';
import LoadingBar from '../../common/LoadingBar';
import AlertError from '../../common/AlertError';
import UpdateFromPacer from '../../common/UpdateFromPacer';
import AllCasesView from './AllCasesView';

export class AssociatedCases extends Component {
  componentDidMount() {
    const { purchase_right_away } = this.props;
    if (purchase_right_away) { this.purchaseData(); } else { this.getData(); }
  }

  getData = () => {
    const { dispatch, case_uuid } = this.props;
    dispatch(irActions.getCaseData({
      type: 'associated_cases',
      case_uuid,
    }));
  }

  purchaseData = () => {
    const { dispatch, case_uuid } = this.props;

    dispatch(irActions.purchaseCaseData({
      type: 'associated_cases',
      case_uuid,
    }));
  }

  render() {
    const { dataReady, error, case_uuid, receipt, lastUpdated, cases } = this.props;
    if (!dataReady) return <LoadingBar />;

    const alertError = error ? <AlertError errors={error} /> : null;

    return (
      <div className="associated-cases">
        { alertError }

        <AllCasesView cases={cases} case_uuid={case_uuid} />

        <UpdateFromPacer
          pacerUpdateHandler={this.purchaseData}
          pacerReceipt={receipt}
          lastUpdated={lastUpdated} />
      </div>
    );
  }
}

AssociatedCases.defaultProps = {
  purchase_right_away: false,
  error: null,
};

AssociatedCases.propTypes = {
  dispatch: PropTypes.func.isRequired,
  case_uuid: PropTypes.any.isRequired,
  purchase_right_away: PropTypes.bool,
  dataReady: PropTypes.bool.isRequired,
  cases: PropTypes.any.isRequired,
  receipt: PropTypes.oneOfType([null, PropTypes.any]).isRequired,
  lastUpdated: PropTypes.any.isRequired,
  error: PropTypes.any,
};

const mapStateToProps = (state) => {
  const irSearch = state.get('irSearch').toJS();
  return {
    dataReady: irSearch.data_ready,
    cases: irSearch.data,
    receipt: irSearch.receipt,
    lastUpdated: irSearch.lastUpdated,
    error: irSearch.error,
  };
};

const mapDispatchToProps = dispatch => ({
  dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(AssociatedCases);



/** WEBPACK FOOTER **
 ** ./src/components/case/associated_cases/AssociatedCases.js
 **/